import { commonService } from '.';

const getListeKP = () => {
    return commonService.get('ListeDc/listeKP');
};

const getSearchKp = (body) => {
    return commonService.getWithParam('ListeDc/listSearchKp', body);
};

const getListeFiltreKp = (body) => {
    return commonService.getWithParam('ListeDc/filtreKp', body);
}
const getListeFiltreSkill = (body) => {
    return commonService.getWithParam('ListeDc/filtreSkill', body);
}

const getListSkills = () => {
    return commonService.get('ListeDc/listSkills');
};

const insertSkills = (idSkill, body) => {
    return commonService.post('ListeDc/insertSkills?idSkill=' + idSkill, body);
};

const deleteSkills = (id) => {
    return commonService.deleteWithParam('ListeDc/deleteSkills?idSkill=' + id);
};


const getListSkillById = (body) => {
    return commonService.getWithParam('ListeDc/listSkillById', body);
};

const getListSkillCategory = () => {
    return commonService.get('ListeDc/listSkillCategory');
};

const getSearchSkills = (body) => {
    return commonService.getWithParam('ListeDc/listSearchSkills', body);
};

const getSearchOtherSkills = (body) => {
    return commonService.getWithParam('ListeDc/listSearchOtherSkills', body);
};

const getListeRechercheDc = (body) => {
    return commonService.getWithParam('ListeDc/recherche', body);
};

const getListeCritereComptence = (body, param) => {
    return commonService.postBodyWithParam('ListeDc/filtreCritereCompetence', body, param);
}

const getListSkillCategoryType = () => {
    return commonService.get('ListeDc/listSkillCategoryType');
};

const getListSkillCategoryByType = (idSkillCategoryType) => {
  return commonService.get('ListeDc/listSkillCategoryByType?idSkillCategoryType=' + idSkillCategoryType);
};

export const listeDcService = {
    getListeKP,
    getSearchKp,
    getListeFiltreKp,
    getListeFiltreSkill,
    getListSkills,
    insertSkills,
    deleteSkills,
    getListSkillById,
    getListSkillCategory,
    getSearchSkills,
    getSearchOtherSkills,
    getListeRechercheDc,
    getListeCritereComptence,
    getListSkillCategoryType,
    getListSkillCategoryByType
};

